import _ from 'underscore';
import { oneLine } from 'common-tags';

function oneLineT_(literals, ...placeholders) {
  return oneLine([T_.raw(literals, ...placeholders)]);
}

function T_(text, ...values) {
  if (Array.isArray(text)) {
    return oneLineT_(text, ...values);
  }
  const vars = values[0];
  if (typeof vars === 'undefined' || !vars) {
    return text;
  }
  let result = _.template(text)(vars);
  const oldsettings = _.templateSettings;
  _.templateSettings = {
    evaluate: /<\[([\s\S]+?)\]>/g,
    interpolate: /<\[=([\s\S]+?)\]>/g,
    escape: /<\[-([\s\S]+?)\]>/g,
  };
  result = _.template(result)(vars);
  _.templateSettings = oldsettings;
  return result;
}

T_.raw = function rawT(literals, ...placeholders) {
  return literals.raw.reduce((str, current, index) => {
    let temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

export { T_ };
